import { Card, CardProps } from "@blueprintjs/core"
import React from "react"
import clsx from "utils/clsx"
import styles from "./styles.module.css"
export type CustomCardProps = CardProps & {
  /**
   * Extract a component for future use
   */
  bordered?: boolean
}
const CustomCard = ({
  className,
  bordered = false,
  ...otherProps
}: CustomCardProps) => {
  return (
    <Card
      className={clsx(bordered && styles["bordered"], className)}
      {...otherProps}
    />
  )
}

export default CustomCard
